import { CACHE_TIMES } from '@/config/cache';
import type { DateRange, SelectedNetwork } from '@/types';
import { useShowPerformanceQuery } from '@/services/revenueApi';

const useShowPerformanceData = (
  selectedNetwork: SelectedNetwork | undefined,
  modalDateRange: DateRange | undefined,
  enabled: boolean = false
) => {
  return useShowPerformanceQuery(
    selectedNetwork?.id ?? '',
    modalDateRange?.from ?? '',
    modalDateRange?.to ?? '',
    {
      enabled,
      refetchOnMount: false,
      staleTime: CACHE_TIMES.SHORT,
    }
  );
};

export default useShowPerformanceData;
